/**
 * A/Bテストの実験名。
 *
 * この文字列は群分けハッシュのソルトになる。実験ごとに必ず別の値にすること。
 * 同じ値を使い回すと、別の実験と群が完全に一致して効果が混ざる。
 *
 * 集計時に BigQuery 側で同じ群を復元するため、**一度公開した実験名は変更しない**。
 * 変更すると全ユーザーの群が入れ替わり、それまでのデータが使えなくなる。
 */

/**
 * メッセージ一覧の好み絞り込みの効果検証。**2群（50/50）**。
 *
 * | 群 | メッセージ一覧 |
 * |---|---|
 * | control | 誰からのメッセージも届く（従来どおり） |
 * | filtered | 好みに合う女性からのメッセージだけ残す |
 *
 * ★オンボーディングは**全員に見せる**ので群に含めない。好みが未登録だと BE が
 *   絞り込まずに全件返し、filtered が control と区別できなくなるため、
 *   絞り込みを測るには全員が好みを登録している必要がある。
 * ★オンボーディング自体の効果はこの実験では測れない（対照群が無い）。
 *   導入前後の比較で見る。
 *
 * 旧値 "pref_onboarding_2026_09"（3群でオンボーディング有無も割っていた版）からは
 * 測る対象が変わったので salt ごと変えている。旧値のまま境界だけ変えると、
 * 集計側が旧定義の群を復元して静かに食い違う。
 */
export const PREFERENCE_ONBOARDING_EXPERIMENT = "msg_pref_filter_2026_09";
